export const landingPageURL = {
  term_and_condition: "https://www.ekalsutra.com/term-and-conditions",
  privacyPolicy: "https://www.ekalsutra.com/privacy-policy",
  refundPolicy: "https://www.ekalsutra.com/refund-policy",
  paymentTerms: "#",
};
